<template>
  <table>
    <tbody>
      <tr v-for="(tax, index) in taxes" :key="index">
        <td>
          <translate
            v-if="tax.inclusive"
            tag="i"
            :tt="{ type: tax.type, rate: tax.rate }"
          >
            Includes {type} ({rate})
          </translate>
          <translate v-else tag="i" :tt="{ type: tax.type, rate: tax.rate }">
            Plus {type} ({rate})
          </translate>
        </td>
        <td class="right">
          <i18n-t keypath="{price} per stay" tag="div">
            <template #price>
              <pu-price
                :price="tax.amount"
                :display-original-price="true"
              /><br />
            </template>
          </i18n-t>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { ChargeTypeTax } from '../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Taxes extends Vue {
  @Prop()
  taxes: ChargeTypeTax[]
}

export default toNative(Taxes)
</script>

<style scoped>
.right {
  text-align: right;
}
</style>
